import React, { ReactElement } from 'react';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { orange50, white } from '../../../constants/colors';

type MagnifierToggleProps = {
  /** ルーペ（拡大表示）が有効か */
  checked: boolean;
  /** ON/OFF切り替え時のハンドラ */
  onChange: () => void;
};

/**
 * OCR結果プレビューのルーペ（拡大表示）ON/OFFトグル（#3079）。
 * パターン結果・自由読取結果の両プレビューで共通利用する。
 * ズームバー左端に配置する想定（marginRight:auto で左寄せ）。
 * 見た目: つまみは常に白、OFFは黒背景に溶けないよう白枠でふち取り、ONは orange50。
 */
const MagnifierToggle = ({ checked, onChange }: MagnifierToggleProps): ReactElement => (
  <FormControlLabel
    control={
      <Switch
        checked={checked}
        onChange={onChange}
        size="small"
        sx={{
          // 暗い画像ビューア上に重ねるため、共通テーマ（#3153）の配色を意図的に上書きする
          // つまみは常に白
          '& .MuiSwitch-thumb': { color: white },
          // OFF時: トラックが黒背景に溶けないよう白枠で縁取る
          '& .MuiSwitch-track': {
            border: `1px solid ${white}`,
            opacity: 0.6,
          },
          // ON時: トラックをorange50（バウンディングボックスと同色）に
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: orange50,
            borderColor: orange50,
            opacity: 1,
          },
        }}
      />
    }
    label={
      <Typography sx={{ fontSize: '14px', color: white, whiteSpace: 'nowrap' }}>
        拡大表示
      </Typography>
    }
    // marginRight:auto で左端に寄せ、ズーム操作系は右寄せのまま保つ
    sx={{ margin: 0, marginRight: 'auto' }}
  />
);

export default MagnifierToggle;
